import Wave from "react-wavify";
import { useState } from "react";
import { Download } from "lucide-react";

function Menu() {
  const [showPdf, setShowPdf] = useState(false);

  return (
    <div id="menu" className="bg-[#f8f6e3]">
      <div>
        <div className="bg-[#9a3415]">
          <Wave
            fill="#f8f6e3"
            paused={true}
            style={{ display: "flex" }}
            options={{
              height: 70,
              amplitude: 50,
              speed: 0.15,
              points: 3,
            }}
          />
        </div>
        <div className="max-w-6xl mx-auto">
          <h1 className="font-black text-5xl text-center text-[#9a3415] mb-8">
            Menu
          </h1>

          {/* Info Section */}
          <div className="px-4 md:px-0 py-6">
            <div className="mb-4">
              <p className="text-center text-lg md:text-xl text-[#9a3415] font-semibold mb-4">
                Dit is onze standaard menukaart
              </p>
              <div className="space-y-3 text-gray-700 text-center">
                <p>Er staat nog meer op de kaart als je bij ons komt eten.</p>
                <p className="font-medium text-[#9a3415]">De keuken sluit alle dagen om 15:00</p>
                <p>Take away van bepaalde drankjes en gerechten mogelijk, vraag ernaar.</p>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col md:flex-row justify-center gap-4 mb-8">
              <button
                onClick={() => setShowPdf(!showPdf)}
                className="hidden md:inline-flex items-center justify-center gap-2 bg-[#9a3415] text-[#f8f6e3] font-bold py-3 px-8 rounded-xl transition-all duration-200 shadow-md hover:bg-[#661f09] hover:shadow-xl"
              >
                {showPdf ? "Verberg Menu" : "Toon Menu"}
              </button>
              <a
                href="/Menukaart_BarElvire_V14.pdf"
                download
                className="w-fit m-auto md:m-0 flex items-center justify-center gap-2 bg-[#9a3415] text-[#f8f6e3] font-bold py-3 px-8 rounded-xl transition-all duration-200 shadow-md hover:bg-[#661f09] hover:shadow-xl"
              >
                <Download size={24} />
                Download
              </a>
            </div>

            {/* Desktop: PDF Viewer */}
            {showPdf && (
              <div className="hidden md:block mb-8">
                <div className="bg-[#9a3415] rounded-2xl p-6 shadow-md overflow-hidden">
                  <div className="h-[700px] bg-white rounded-xl overflow-hidden border-4 border-[#f8f6e3]">
                    <iframe
                      src="/Menukaart_BarElvire_V14.pdf#toolbar=1&navpanes=0&scrollbar=1"
                      title="Menu PDF"
                      className="w-full h-full"
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Mobile: Download CTA */}
            <div className="md:hidden text-center">
              <p className="text-[#f8f6e3] text-sm mb-4">Bekijk de menukaart op je apparaat</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Menu;